import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import iconMap from "./Icons/iconMap";

const StyledIcon = styled.span`
  ${({ size }) =>
    size &&
    css`
      width: ${size};
      height: ${size};
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;

const Icon = ({ name, size, color, className, testId }) => {
  const IconComponent = iconMap[name];
  return (
    <StyledIcon size={size} color={color} className={className}>
      {IconComponent && <IconComponent color={color} testId={testId} />}
    </StyledIcon>
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  testId: PropTypes.string,
};

export default Icon;
